import React from 'react';
import { SavedViewsCarousel as SavedViewsCarouselComponent } from '../../components';
import { useAppContext } from '../../context/AppState.jsx';
import i18n from '../../i18n';

export default function SavedViewsCarousel() {
	const [state, dispatch] = useAppContext();

	const carouselContent = state?.carouselContent || [];

	const slides = carouselContent.map((slide) => {
		let viewName;
		switch (slide.view) {
			case 'trends':
				viewName = i18n.t('Map').toUpperCase();
				break;
			default:
				viewName = i18n.t(slide.view).toUpperCase();
		}

		// Handle meas - it can be a string or already an array from getCarouselContent
		const measArray = slide.meas ? (Array.isArray(slide.meas) ? slide.meas : slide.meas.split(/[-|]/)) : [];

		const measIcons = measArray.map((meas) => ({
			src: `/img/icons/${meas.toUpperCase()}.svg`,
			alt: meas,
		}));

		return {
			// eslint-disable-next-line i18next/no-literal-string
			title: slide[`${i18n.language}_name`],
			// eslint-disable-next-line i18next/no-literal-string
			description: slide[`${i18n.language}_description`],
			link: `app.html?v=${slide.uid}`, // eslint-disable-line i18next/no-literal-string
			meas: measArray,
			loc: slide.loc,
			view: slide.view,
			viewName,
			viewIcon: `/img/icons/${slide.view}.svg`,
			measIcons,
		};
	});

	return <SavedViewsCarouselComponent slides={slides} />;
}
